// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    'backbone',
    './ProtocolModel'
], (Globals, $, _, Backbone, ProtocolModel) => {
    const ProtocolCollection = Backbone.Collection.extend({
        url: Globals.baseUrl + 'protocols/protocol',
        model: ProtocolModel
    }, {
        deleteItems(options) {
            console.log(options.items);
            $.ajax({
                url: Globals.baseUrl + 'protocols/deleteItems',
                data: { ids: options.items },
                traditional: true,
                type: 'POST',
                dataType: 'JSON',
                success(data) {
                    if (_.isFunction(options.success)) {
                        options.success(data);
                    }
                }
            });
        }
    });
    return ProtocolCollection;
});



// WEBPACK FOOTER //
// ./src/components/protocol/models/ProtocolCollection.js